import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { IonicApp, IonicModule, IonicPageModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { MyApp } from "./app.component";
import { EntityPage } from "../pages/entity/entity";
import { CustomerOverviewPage } from "../pages/customer-overview/customer-overview";
import { LoginPage } from "../pages/login/login";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { TrainOverviewPage } from "../pages/train-overview/train-overview";
import { ReportsPage } from "../pages/reports/reports";
import { PipesModule } from "../pipes/pipes.module";
import { DataProvider } from "../providers/data/data";
import { ComponentsModule } from "../components/components.module";
import { KpiExplorerPage } from "../pages/kpi-explorer/kpi-explorer";
import { CustomersPage } from "../pages/customers/customers";
import { NotificationsPage } from "../pages/notifications/notifications";
import { LogBookPage } from "../pages/log-book/log-book";
import { Network } from "@ionic-native/network";
import { AddFormPage } from "../pages/add-form/add-form";
import { NotificationsDetailsPage } from "../pages/notifications-details/notifications-details";
import { IonicStorageModule } from "@ionic/storage";
import { FavoriteProvider } from "../providers/favorite/favorite";
import { TrendExplorer_2PageModule } from "../pages/trend-explorer-2/trend-explorer-2.module";
import { EquipmentDetailsPage } from "../pages/equipment-details/equipment-details";
import { ApplicationApiProvider } from "../providers/application-api/application-api";
import { DemoProvider } from "../providers/demo/demo";
import { StarmsClientProvider } from "../providers/starms-client/starms-client";
import { TimeProvider } from "../providers/time/time";
import { HTTP } from "@ionic-native/http";
import { InterceptorProvider } from "../providers/interceptor/interceptor";
import { KpiProvider } from "../providers/kpi/kpi";
import { File } from "@ionic-native/file";
import { Keychain } from "@ionic-native/keychain";
import { KpiDetailsPage } from "../pages/kpi-details/kpi-details";
import { KpiPowerGenPage } from "../pages/kpi-power-gen/kpi-power-gen";
import { SupportPage } from "../pages/support/support";
import { ResetnavProvider } from "../providers/resetnav/resetnav";
import { LicensePage } from "../pages/license/license";
import { SignalTagUtilProvider } from "../providers/signal-tag-util/signal-tag-util";
import { MarketPlaceInfoPage } from "../pages/market-place-info/market-place-info";
import { EntitiesProvider } from "../providers/entities/entities";
import { DirectivesModule } from "../directives/directives.module";
import { InstrumentHealthPage } from "../pages/instrument-health/instrument-health";
import { BannersProvider } from "../providers/banners/banners";
import { TemplateProvider } from "../providers/template/template";
import { LdsClientService } from "../providers/lds-client/lds-client.service";
import { OpServiceService } from "../providers/lds-client/op-service.service";
import { TrendExplorerComponent } from "../components/trend-explorer/trend-explorer.component";
import { TagsService } from "../providers/trend-live-services/tags.service";
import { TrendExplorerService } from "../components/trend-explorer/trend-explorer.service";
import { VirtualScrollerModule } from "ngx-virtual-scroller";
@NgModule({
  declarations: [
    MyApp,
    EntityPage,
    CustomerOverviewPage,
    TrainOverviewPage,
    LoginPage,
    ReportsPage,
    KpiExplorerPage,
    CustomersPage,
    NotificationsPage,
    LogBookPage,
    AddFormPage,
    NotificationsDetailsPage,
    EquipmentDetailsPage,
    KpiDetailsPage,
    KpiPowerGenPage,
    SupportPage,
    LicensePage,
    MarketPlaceInfoPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      tabsHideOnSubPages: true,
      locationStrategy: "path",
    }),
    HttpClientModule,
    IonicPageModule,
    PipesModule,
    ComponentsModule,
    VirtualScrollerModule,
    DirectivesModule,
    BrowserAnimationsModule,
    IonicStorageModule.forRoot({
      name: "__myhealth",
    }),
    TrendExplorer_2PageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    EntityPage,
    CustomerOverviewPage,
    TrainOverviewPage,
    LoginPage,
    ReportsPage,
    KpiExplorerPage,
    CustomersPage,
    NotificationsPage,
    LogBookPage,
    AddFormPage,
    NotificationsDetailsPage,
    EquipmentDetailsPage,
    KpiDetailsPage,
    KpiPowerGenPage,
    SupportPage,
    LicensePage,
    MarketPlaceInfoPage,
    InstrumentHealthPage,
  ],
  providers: [
    HTTP,
    SplashScreen,
    DataProvider,
    InAppBrowser,
    Network,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorProvider,
      multi: true,
    },
    FavoriteProvider,
    ApplicationApiProvider,
    DemoProvider,
    StarmsClientProvider,
    LdsClientService,
    OpServiceService,
    TimeProvider,
    KpiProvider,
    File,
    Keychain,
    ResetnavProvider,
    SignalTagUtilProvider,
    EntitiesProvider,
    BannersProvider,
    TemplateProvider,
    TrendExplorerComponent,
    TagsService,
    TrendExplorerService,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts